
define( 'FORCES_AND_MOTION_BASICS/../nls/forces-and-motion-basics-strings',{
          "root": true,
          "ca": true,
          "da": true,
          "de": true,
          "el": true,
          "es": true,
          "es-es": true,
          "es-pe": true,
          "eu": true,
          "fa": true,
          "fr": true,
          "gl": true,
          "hu": true,
          "it": true,
          "iw": true,
          "mk": true,
          "nl": true,
          "pl": true,
          "pt-br": true,
          "sk": true,
          "sr": true,
          "sv": true,
          "ta": true,
          "tr": true,
          "vi": true,
          "zh-tw": true
        } );